module.exports = __webpack_public_path__ + "static/media/baseMeme12thumb.00fa22ce.jpg";